import { ApprovalFlows } from '@mint-sdk/api-approval-flows';

const useCreateFlowMutation = () => {
  return ApprovalFlows.createFlow();
};

export default useCreateFlowMutation;
